// CustomToastContainer.jsx
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomToastContainer = () => {
  return (
    <ToastContainer
      position="top-center"
      style={{
        top: "150px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "1000px",
        zIndex: 9999,
      }}
    />
  );
};

export default CustomToastContainer;
